(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (event) {
  var link = event.target.closest('[data-mobile-nav] a[href$="#contacto"]');
  if (link) link.closest('[data-mobile-nav]').classList.remove('open');
});

  } catch(e) { console.error(e); }
})();
})();
